// $FlowExpectedError
import { OmqHelp } from '@omq.ai/omq-help-react';

import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Dialog, DialogSizes } from '@admin/shared/components/dialogs/dialog';
import { useSupportContext } from '@admin/shared/context/support';

// create styles for desk
const useStyles = makeStyles(
  () => {
    return {
      paper: {
        height: '80%',
      },
      omqContainer: {
        '& #omq-help-container': {
          width: '100%',
        },
      },
    };
  },
  {
    name: 'OMQHelpSupport',
  },
);

/**
 * Component to provide OMQ Help Support.
 *
 * @returns {Node|null}
 */
export function OMQHelpSupport(): JSX.Element {
  const styles = useStyles();
  const { supportData, hideSupport } = useSupportContext();

  if (supportData == null) {
    return null;
  }

  const { account, apiKey } = supportData;

  // render OMQ Help in a dialog component
  return (
    <Dialog
      size={DialogSizes.AUTO}
      classes={{
        paper: styles.paper,
      }}
      onClose={hideSupport}>
      <Box
        width={800}
        height={1}
        pr={3}
        display="flex"
        flexDirection="column"
        alignItems="center"
        overflow="auto"
        className={styles.omqContainer}>
        <OmqHelp account={account} apiKey={apiKey} />
      </Box>
    </Dialog>
  );
}
